import { DEFAULT_FORMATTER_LOCALE } from '../../constants/defaultFormatterLocale'
import { getFormatLocale } from '../getFormatLocale'
import { DEFAULT_DECIMAL_SEPARATOR } from './constants/defaultDecimalSeparator'
import { LocaleSeparators } from './types/LocaleSeparators'

export const getNumberSeparators = (locale?: string): LocaleSeparators => {
  const intlLocale = getFormatLocale(locale || DEFAULT_FORMATTER_LOCALE)
  const exampleNumber = 1234.6789
  const formatted = new Intl.NumberFormat(intlLocale).format(exampleNumber)
  const separatorsString = formatted.replace(/\d/g, '') // removed all digits
  const thousandSeparator = separatorsString.length > 1 ? separatorsString[0] : ''
  const decimalSeparator = separatorsString.slice(-1) || DEFAULT_DECIMAL_SEPARATOR

  return { decimalSeparator, thousandSeparator }
}
